var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"pt-3",attrs:{"fluid":""}},[_vm._v(" Line登入 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }